/* Copyright (c) 2021, NVIDIA CORPORATION.  All rights reserved.
 * NVIDIA CORPORATION and its licensors retain all intellectual property
 * and proprietary rights in and to this software, related documentation
 * and any modifications thereto.  Any use, reproduction, disclosure or
 * distribution of this software and related documentation without an express
 * license agreement from NVIDIA CORPORATION is strictly prohibited.
 */

import { BridgeConfig, WindowConfig, AppWindowNames } from 'crimson';

import { EnvironmentConfig } from './base';
import { releaseConfiguration, loggerConfig } from './release';
import { bridgeMocks } from './mock';
import { localeConfig } from './localeconfig';

const windowConfig: WindowConfig = {
    name: AppWindowNames.Vdkplaytest
};

const bridgeConfig: BridgeConfig = {
    mocks: bridgeMocks
};

const environment: EnvironmentConfig = {
    bridge: bridgeConfig,
    logger: loggerConfig,
    window: windowConfig,
    locale: localeConfig,
    configFileName: 'assets/config.json',
    ...releaseConfiguration
};

export { environment };
